const dayOfWeekString = (dateValue) => {
  if (!dateValue) return null

  const dayOfWeek = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
  }
  const date = new Date(dateValue)

  return dayOfWeek[date.getDay()]
}

export default dayOfWeekString
